import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: {
      id: 0,
      name: '',
      email: '',
      company: null,
      company_type: null,
    }
  },
  reducers: {
    updateUser: (state, action) => {
      const updates = action.payload; // Destructure updates from the action payload
      state.user = { ...state.user, ...updates }; // Merge the updates into the state
    },
    updateUserCompany: (state, action) => {
      const updates = action.payload; // Destructure updates from the action payload
      state.user.company = { ...state.user.company, ...updates };
    },
    updateUserBrandMarket: (state, action) => {
      state.user.company.market = { ...state.user.company.market, ...action.payload }
    },
    updateUserAgencyAvailability: (state, action) => {
      state.user.company.availability_status = action.payload
    },
    updateAgencyAbout: (state, action) => {
      state.user.company.about = { ...state.user.company.about, ...action.payload }
    },
    updateAgencyMarket: (state, action) => {
      state.user.company.market = { ...state.user.company.market, ...action.payload }
    },
    updateAgencyCountry: (state, action) => {
      state.user.company.country = action.payload
    },
    updateRegions: (state, action) => {
      state.user.company.regions = action.payload
    },
    updateAgencyHowWeWork: (state, action) => {
      state.user.company.sales_strat = action.payload.sales_strat;
      state.user.company.b2b_size = action.payload.b2b_size;
    },
    updateAgencyBrandExperience: (state, action) => {
      state.user.company.brand_experience = action.payload
    },
    updateAgencySalesDetails: (state, action) => {
      state.user.company.sales_details = action.payload
    },
    updateAgencyShowrooms: (state, action) => {
      state.user.company.showrooms = action.payload
    },
    updateVisionGoals: (state, action) => {
      state.user.company.vg_brand_partnership = action.payload.vg_brand_partnership;
      state.user.company.vg_sales = action.payload.vg_sales;
      state.user.company.vg_strengths = action.payload.vg_strengths;
    },
    updateImageCaption: (state, action) => {
      state.user.company.images[action.payload.index].caption = action.payload.caption;
    },
    addAgencyImage: (state, action) => {
      let images = state.user.company.images;
      if(action.payload?.length > 0){
        images = [...images, ...action.payload]
      }else{
        images.push(action.payload);
      }
      
      state.user.company.images = images;
    },
    deleteAgencyImage: (state, action) => {
      const images = state.user.company.images.filter(images => {
        return images.id !== action.payload.id;
      });

      state.user.company.images = images;
    },
    deleteAgencyVideo: (state) => {
      state.user.company.showroom_video = null
    },
    deleteBrand: (state, action) => {
      if (state.user.company && state.user.company.brands) {
        state.user.company.brands = state.user.company.brands.filter(
          brand => brand.id !== action.payload
        );
      }
    },
    logout: (state) => {
      localStorage.removeItem('token');
      localStorage.removeItem('last_page');
      window.location.href = window.location.origin;
    },
    updateUserBrand: (state, action) => {
      state.user.company.brands = state.user.company.brands.map(item => {
        if(item.id === action.payload.id){
          let tempItem = action.payload;
          try {
            tempItem.market = JSON.parse(tempItem.market);
          } catch (error) {
            //
          }
          return { ...item, ...tempItem };
        }else{
          return item;
        }
      });
    },
    deleteBrandVideo: (state, action) => {
      state.user.company.brands = state.user.company.brands.map(item =>
        item.id === action.payload.entity_id ? { ...item, showroom_video: null } : item
      );
    },
    deleteBrandImage: (state, action) => {
      state.user.company.brands = state.user.company.brands.map(item => {
        if (item.id === action.payload.entity_id) {
          item.images = item.images.filter(images => {
            return images.id !== action.payload.id;
          });
          return item;
        } else {
          return item;
        }
      });
    },
    addBrandImage: (state, action) => {
      state.user.company.brands = state.user.company.brands.map(item => {
        if (item.id == action.payload.entity_id) {
          item.images.push(action.payload);
          return item;
        } else {
          return item;
        }
      });
    },
    updateBrandImage: (state, action) => {
      state.user.company.brands = state.user.company.brands.map(item => {
        if (item.id === action.payload.entity_id) {
          item.images = item.images.map(item =>
            item.id === action.payload.id ? { ...item, ...action.payload } : item
          );
          return item;
        } else {
          return item;
        }
      });
    },
  },
});

export const {
  updateUser,
  updateUserCompany,
  updateUserBrandMarket,
  updateUserAgencyAvailability,
  updateAgencyAbout,
  updateAgencyMarket,
  updateAgencyCountry,
  updateRegions,
  updateAgencyHowWeWork,
  updateAgencyBrandExperience,
  updateAgencySalesDetails,
  updateAgencyShowrooms,
  updateVisionGoals,
  updateImageCaption,
  addAgencyImage,
  deleteAgencyImage,
  deleteAgencyVideo,
  deleteBrand,
  logout,
  updateUserBrand,
  deleteBrandVideo,
  addBrandImage,
  deleteBrandImage,
  updateBrandImage,
} = userSlice.actions;

export default userSlice.reducer;